import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../helpers";
import ManageVoters from "./manage-voters";
import { useParams } from "react-router";
import { LoadingState } from "../../components";
import { FTPBreadCrumbs } from "../../components-new";

const ManageVotersdex = observer((props: any) => {
  const { projectid } = useParams();
  const { voterReachOutStore } = useStore();
  const { isLoading } = voterReachOutStore;

  const crumbs = [
    { name: "DashBoard", href: `/project/${projectid}`, current: true },
    { name: "Manage Voters", href: "#", current: true },
  ];

  const Actions = (
    <></>
  )

  return (
    <>
      {isLoading && <LoadingState />}
      <div className="sticky top-[4rem] z-20 [&_nav]:mb-0 [&_nav]:!top-0 [&_nav]:!shadow-none [&_nav]:!border-b-0 [&_nav]:bg-transparent">
        <FTPBreadCrumbs crumbs={crumbs} />
      </div>
      <ManageVoters />
    </>
  );
});

export default ManageVotersdex;
